module.exports = __webpack_public_path__ + "media/engagement_responsable/redonner-53d5815e.png";